import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";

import alertify from "alertifyjs";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiServiceService } from "../../../../../Services/api-service.service";
import { ToastService } from "../../../../../Services/ToastService";
@Component({
  selector: "app-success-continue",
  templateUrl: "./success-continue.component.html",
  styleUrls: ["./success-continue.component.css"],
})
export class SuccessContinueComponent implements OnInit {
  @Input() asin_no: any;
  @ViewChild("textToCopy") textToCopyRef: ElementRef;

  copySuccess = false;

  screenHeight = window.screen.height - 271; // 1058
  minHeight = "min-height: " + this.screenHeight + "px !important";

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = "min-height: " + this.screenHeight2 + "px !important";
  isloading: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiServiceService,
    private spinner: ToastService
  ) {}

  goHome() {
    this.router.navigate(['/']);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params["asin_no"]) {
        this.asin_no = params["asin_no"];
      }
    });
  }

  copyText(text: string) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.copySuccess = true;
        setTimeout(() => {
          this.copySuccess = false;
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  }


  printIndividualAsinCard() {
    
    this.spinner.spin();
    let url = `/auth/enumeration/print/asin/card/corporate/${this.asin_no}`;

    alertify.set("notifier", "position", "top-center");
    alertify.success("Downloading ...");

    this.apiService.login(url, {}, { responseType: "blob" }).subscribe(
      (response: Blob) => {
        alertify.set("notifier", "position", "top-center");
        alertify.success("Download successful");

        const blob = new Blob([response], { type: "application/pdf" });

        // Create a Blob URL for the PDF content
        const blobUrl = window.URL.createObjectURL(blob);

        // Open PDF in a new tab
        // window.open(blobUrl, '_blank');

        const file = new Blob([response], { type: "application/pdf" });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        // Optionally, trigger a download by creating an anchor element
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.target = "_blank";
        downloadLink.download = this.asin_no + "corporate_asin_card.pdf"; // File name for download

        // Uncomment this line to trigger the download automatically
        downloadLink.click();
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        this.isloading = false;
        alertify.set("notifier", "position", "top-center");
        alertify.error("Error performing this operation");
      }
    );
  }
}
